import styled, { css } from 'styled-components';

export const RateEmojiContainer = styled.div<{
  value: 'true' | 'false' | undefined;
}>`
  .rate-emoji {
    font-size: 1.6rem;
    margin-right: 10px;
    opacity: 0.4;
    transition: all 0.2s;

    .rate-emoji-happy-icon {
      color: ${({ theme }) => theme.colors.green};
    }
    .rate-emoji-sad-icon {
      color: ${({ theme }) => theme.colors.red};
    }
  }

  .rate-emoji-happy {
    ${({ value }) =>
      value === 'true' &&
      css`
        opacity: 1;
      `};
  }
  .rate-emoji-sad {
    ${({ value }) =>
      value === 'false' &&
      css`
        opacity: 1;
      `};
  }
`;
